export default __webpack_public_path__ + "static/media/Titel_image_Delft.ea51865f.jpg";